// Fp
import {DRAFT_TITLE_CHANGE, DRAFT_CONTENT_CHANGE} from '../../constants';

export const initialState = {
  title: '',
  content: null
}

export default function draft(state = initialState, action) {
  switch (action.type) {
    case DRAFT_TITLE_CHANGE:
      if (!action.title) {
        return {
          ...state,
          title: initialState.title
        }
      } else {
        return {
          ...state,
          title: action.title
        }
      }
    case DRAFT_CONTENT_CHANGE:
      if (!action.content) {
        return {
        ...state,
          content: initialState.content
        }
      } else {
        return {
          ...state,
          content: action.content
        }
      }
    default:
      return state;
  }
}


/** WEBPACK FOOTER **
 ** ./src/store/reducers/draft.js
 **/